import ApplicationController from "../application_controller"

class FormController extends ApplicationController {
  static targets = ['icon']

  connect() {
    const icons = this.iconTargets
    icons.forEach((buttonElement) => {
      buttonElement.addEventListener('click', () => {
        icons.forEach(icon => icon.classList.remove('active'))
        buttonElement.classList.add('active')
      })
    })
  }
}

export default FormController
